import React from "react"
import PropTypes from "prop-types"
import CheckMark from "assets/icons/check-mark.svg"

import {
  StyledWrapper,
  StyledImg,
  StyledTextWrapper,
  StyledTitle,
  StyledAddress,
  StyledImgWrapper,
  StyledOverlay,
} from "./Project.styles"

const Project = ({ project, isSelected, toggleSelection }) => {
  const {
    name,
    overview: { city },
    bannerImages,
    blogIcon,
  } = project
  return (
    <StyledWrapper
      as="button"
      type="button"
      style={{ padding: 0, border: 0, textAlign: "left" }}
      aria-label={`Subscribe to ${name}`}
      aria-pressed={isSelected}
      onClick={toggleSelection}
      data-testid="subscribeProject"
    >
      <StyledImgWrapper isSelected={isSelected}>
        {blogIcon ||
          (bannerImages[0] && (
            <StyledImg
              src={bannerImages[0].image}
              alt=""
              loading="lazy"
              data-testid="subscribeProjectImage"
            />
          ))}
        <StyledOverlay data-testid="subscribeProjectOverlay">
          <CheckMark
            aria-hidden="true"
            focusable="false"
            data-testid="subscribeProjectCheckMark"
          />
        </StyledOverlay>
      </StyledImgWrapper>
      <StyledTextWrapper data-testid="subscribeProjectTextWrapper">
        <StyledTitle data-testid="subscribeProjectTextTitle">
          {name}
        </StyledTitle>
        <StyledAddress data-testid="subscribeProjectTextAddress">
          {city && `${city.name}, ${city.stateCode}`}
        </StyledAddress>
      </StyledTextWrapper>
    </StyledWrapper>
  )
}
Project.propTypes = {
  project: PropTypes.shape({
    overview: PropTypes.shape({
      city: PropTypes.shape({
        name: PropTypes.string,
        stateCode: PropTypes.string,
      }),
    }),
    bannerImages: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.oneOfType([
          PropTypes.shape({
            original: PropTypes.string,
            large: PropTypes.string,
            medium: PropTypes.string,
            small: PropTypes.string,
          }),
          PropTypes.string,
        ]),
        id: PropTypes.string,
      })
    ),
    name: PropTypes.string.isRequired,
    blogIcon: PropTypes.node,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  toggleSelection: PropTypes.func,
}
Project.defaultProps = {
  toggleSelection: () => {},
}
export default Project
